import { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

type CounterPropsTYpe = {
  noPrefix?: boolean;
  number: number;
};

const Counter = ({ noPrefix, number, className }: CounterPropsTYpe) => {
  const [didViewCountUp, setDidViewCountUp] = useState(false);
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
  });

  useEffect(() => {
    if (inView) {
      onVisibilityChange(true);
    }
  }, [inView]);

  const onVisibilityChange = (isVisible) => {
    if (isVisible) {
      setDidViewCountUp(true);
    }
  };

  return (
    <div ref={ref} className={className}>
      <CountUp start={0} end={didViewCountUp ? number : 0} prefix={noPrefix ? undefined : '0'} duration={2} />
    </div>
  );
};

export default Counter;
